export default __webpack_public_path__ + "static/devview-2ed341bb38672f477e9822fadc5519d3.gif";